var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "18 12 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_5459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6905 18.8507C34.6905 18.8507 34.6356 18.7421 34.5806 18.7421C33.6467 17.7105 32.4382 17.2218 31.0648 17.1675C30.2957 17.1132 29.5815 17.3304 28.9223 17.6562C27.7137 18.1991 26.8897 19.1222 26.3953 20.371C26.0107 21.4026 26.0107 22.4342 26.3403 23.4658C26.5601 24.1717 26.9446 24.8232 27.494 25.3662C27.5489 25.4205 27.6039 25.4748 27.6588 25.5291C27.7137 25.5834 27.7137 25.5834 27.7687 25.6377C28.6476 26.4521 29.8013 26.9408 31.0648 26.9408C33.7566 26.9408 35.954 24.7689 35.954 22.1084C35.8991 20.8596 35.4596 19.7194 34.6905 18.8507ZM26.8897 23.0858C26.8348 22.1084 27.0545 21.1854 27.6039 20.3167C28.2631 19.2307 29.2519 18.4706 30.5154 18.1448C31.7789 17.819 32.9875 17.9276 34.1411 18.5792C34.1961 18.5792 34.1961 18.6335 34.251 18.6335C35.1849 19.5022 35.7892 20.6967 35.7892 22.1084C35.7892 24.6603 33.6467 26.7779 31.0648 26.7779C29.7463 26.7779 28.5378 26.2349 27.6588 25.3119C27.2193 24.6061 26.9446 23.9002 26.8897 23.0858Z",
    fill: "#CACBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1964 18.6338C34.1414 18.6338 34.1414 18.5795 34.0865 18.5795C32.9329 17.928 31.7243 17.8194 30.4608 18.1452C29.1973 18.471 28.2634 19.2311 27.5492 20.317C27.0548 21.1315 26.7801 22.1088 26.8351 23.0861C26.89 23.9006 27.1097 24.6064 27.5492 25.3123C28.4282 26.181 29.6368 26.7783 30.9552 26.7783C33.5371 26.7783 35.6796 24.6607 35.6796 22.1088C35.7895 20.6971 35.1852 19.5026 34.1964 18.6338Z",
    fill: "#E8E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0304 13.2035C36.6133 11.0859 33.9215 10 31.0648 10C29.6915 10 28.3181 10.2715 26.8898 10.7601C22.6048 12.2804 20.0229 15.4839 19.1988 19.9362C18.5945 23.3025 19.3636 26.4517 21.561 29.1665C24.8022 33.1301 27.6589 37.3109 30.1309 41.8175C30.4056 42.3062 30.6803 42.8491 31.0099 43.3921C31.1198 43.2292 31.1747 43.1749 31.1747 43.1206C32.4931 40.6773 33.8665 38.2882 35.4047 36.0078C36.888 33.7817 38.4261 31.6098 40.1841 29.6009C41.8321 27.5919 42.821 25.3658 42.9858 22.7596C43.1506 18.9589 41.8871 15.7011 39.0304 13.2035ZM31.3395 28.8407C31.2296 28.8407 31.1198 28.8407 31.0099 28.8407C27.1095 28.8407 24.143 25.7459 24.0331 22.108C23.9233 18.3073 26.9996 15.1581 30.7902 15.0495C34.6906 14.9409 37.8768 17.9272 37.9867 21.7822C38.0416 25.583 35.0751 28.6778 31.3395 28.8407Z",
    fill: "url(#paint0_linear_206_5459)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_206_5459",
    x1: 19.0074,
    y1: 26.6869,
    x2: 42.9424,
    y2: 26.6869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0421348,
    stopColor: "#FDC694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0934066,
    stopColor: "#FCBD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4117,
    stopColor: "#F6883B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5556,
    stopColor: "#F37421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37421"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_5459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMin);
export default __webpack_public_path__ + "static/media/logo_min.627a6ecbc831791be470207e6b1563d1.svg";
export { ForwardRef as ReactComponent };